import React from "react";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme/theme";
import { AuthProvider } from "./services/AuthContext";
import ProtectedRoute from "./services/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";
import PosPage from "./pages/PosPage";
import CashSessionPage from "./pages/CashSessionPage";
import CashRegisterSelectionPage from "./pages/CashRegisterSelectionPage";
import DocumentDetailPage from "./pages/DocumentDetailPage";
import DocumentEditPage from "./pages/DocumentEditPage";
import ExportsDocumentsPage from "./pages/ExportsDocumentsPage";
import StatsPage from "./pages/StatsPage";
import ItemsAdminPage from "./pages/admin/ItemsAdminPage";
import CategoriesAdminPage from "./pages/admin/CategoriesAdminPage";
import CategoryDetailPage from "./pages/admin/CategoryDetailPage";
import ItemDetailPage from "./pages/admin/ItemDetailPage";
import CustomersAdminPage from "./pages/admin/CustomersAdminPage";
import CustomerDetailPage from "./pages/admin/CustomerDetailPage";
import CustomerCreatePage from "./pages/admin/CustomerCreatePage";
import CustomerEditPage from "./pages/admin/CustomerEditPage";
import CustomerTypesAdminPage from "./pages/admin/CustomerTypesAdminPage";
import UsersAdminPage from "./pages/admin/UsersAdminPage";
import PaymentMethodsAdminPage from "./pages/admin/PaymentMethodsAdminPage";
import PricingAdminPage from "./pages/admin/PricingAdminPage";
import SettingsPage from "./pages/admin/SettingsPage";
import SuperadminEntitiesPage from "./pages/superadmin/SuperadminEntitiesPage";
import SuperadminAdministrationPage from "./pages/superadmin/SuperadminAdministrationPage";
import SuperadminEntityOnboardingPage from "./pages/superadmin/SuperadminEntityOnboardingPage";
import SuperadminEntityDetailPage from "./pages/superadmin/SuperadminEntityDetailPage";
import NotFoundPage from "./pages/NotFoundPage";
import AppLayout from "./components/layout/AppLayout";
import SingleTabGuard from "./components/layout/SingleTabGuard";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SingleTabGuard>
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }>
              <Route path="/home" element={<HomePage />} />
              <Route path="/pos" element={<PosPage />} />
              <Route path="/cash-session" element={<CashSessionPage />} />
              <Route
                path="/cash-register-selection"
                element={<CashRegisterSelectionPage />}
              />
              <Route
                path="/exports-documents"
                element={<ExportsDocumentsPage />}
              />
              <Route
                path="/documents"
                element={<Navigate to="/exports-documents" replace />}
              />
              <Route path="/documents/:id" element={<DocumentDetailPage />} />
              <Route
                path="/documents/:id/edit"
                element={<DocumentEditPage />}
              />
              <Route
                path="/reports"
                element={<Navigate to="/exports-documents" replace />}
              />
              <Route path="/stats" element={<StatsPage />} />
              <Route path="/admin/items" element={<ItemsAdminPage />} />
              <Route path="/admin/items/:itemId" element={<ItemDetailPage />} />
              <Route
                path="/admin/categories"
                element={<CategoriesAdminPage />}
              />
              <Route
                path="/admin/categories/:categoryId"
                element={<CategoryDetailPage />}
              />
              <Route path="/admin/customers" element={<CustomersAdminPage />} />
              <Route
                path="/admin/customers/new"
                element={<CustomerCreatePage />}
              />
              <Route
                path="/admin/customers/:customerId"
                element={<CustomerDetailPage />}
              />
              <Route
                path="/admin/customers/:customerId/edit"
                element={<CustomerEditPage />}
              />
              <Route
                path="/admin/customer-types"
                element={<CustomerTypesAdminPage />}
              />
              <Route path="/admin/users" element={<UsersAdminPage />} />
              <Route
                path="/admin/payment-methods"
                element={<PaymentMethodsAdminPage />}
              />
              <Route path="/admin/settings" element={<SettingsPage />} />
              <Route path="/admin/pricing" element={<PricingAdminPage />} />
              <Route
                path="/superadmin/entities"
                element={<SuperadminEntitiesPage />}
              />
              <Route
                path="/superadmin/entities/new"
                element={<SuperadminEntityOnboardingPage />}
              />
              <Route
                path="/superadmin/entities/:companyId"
                element={<SuperadminEntityDetailPage />}
              />
              <Route
                path="/superadmin/administration"
                element={<SuperadminAdministrationPage />}
              />
              <Route path="/" element={<Navigate to="/home" replace />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </AuthProvider>
      </Router>
      </SingleTabGuard>
    </ThemeProvider>
  );
}

export default App;
